<template>
    <footer id="app-footer">
        <div id="newsletter">
            <h2>
                Infos anfordern
            </h2>
            <p>Wir schicken Ihnen kostenlos und unverbindlich Infos zur Cat4School-Plattform zu.</p>
            <form action="#">
                <input
                    type="hidden"
                    name="subject"
                    value="Infoanfrage Website Cat4School"
                >
                <input
                    type="email"
                    name="email"
                    placeholder="E-Mail-Adresse"
                    required
                ><button type="submit">
                    Anfordern
                </button>
                <div id="result-message">
                    Vielen Dank. Wir melden uns in Kürze bei Ihnen!
                </div>
            </form>
        </div>
        <div
            id="column1"
            class="column"
        >
            <p>+49 162-5673-212</p>
            <p v-html="kontaktEmailHtml" />
        </div>
        <div
            id="column2"
            class="column"
        >
            <p>
                <v-icon x-small>
                    fa-external-link-alt
                </v-icon>
                <a
                    href="https://cat4school.de/kontakt"
                    target="_blank"
                >
                    Kontakt
                </a>
            </p>
            <p>
                <v-icon x-small>
                    fa-external-link-alt
                </v-icon>
                <a
                    href="https://cat4school.de/impressum"
                    target="_blank"
                >
                    Impressum
                </a>
            </p>
            <p>
                <v-icon x-small>
                    fa-external-link-alt
                </v-icon>
                <a
                    href="https://cat4school.de/produkt.html#section-faq"
                    target="_blank"
                >
                    faq
                </a>
            </p>
        </div>
        <div id="bottom">
            <p>© cat4school® 2020</p>
        </div>
        <div id="icons">
            <i class="fab fa-instagram" />
            <i class="fab fa-facebook-f" />
            <i class="fab fa-twitter" />
            <i class="fas fa-globe-europe" />
            <i class="fas fa-user" />
        </div>
    </footer>
</template>

<script>
export default {
    name: 'AppFooter',
    data(){
        return {
            kontaktEmailHtml: `<a href="mailto: kontakt@cat4school.de">kontakt@cat4school.de</a>`
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/palettes.scss";
@import "@/assets/css/extends.scss";
    footer#app-footer{
        position: relative;
        margin-top: 5em;
        bottom: 0;

        display: grid;
        grid-template-columns: 1fr auto;
        
        background-color: #37474F;
        p {
            padding: 0;
            margin: 0;
        }
        a {
            color: initial;
        }

        > div#newsletter{
            display: none;
            padding: 2rem 3rem;
            background-color: #F5F6F7;
            > h2{
                color: palette(Cyan, 500);
            }
            > p{
                margin: 1rem 0;
                width: 16rem;
            }
            > form{
                > input{
                    width: 15rem;
                    padding: 0.5rem 1rem;
                    border: 2px solid palette(Cyan, 500);
                    border-radius: .5em;
                    &::placeholder{
                        font-weight: bold;
                        color: palette(Cyan, 500);
                    }
                }
                > button{
                    background-color: palette(Cyan, 500);
                    color: #fff;
                    border-radius: .25rem;
                    padding: .57rem 1rem;
                    font-size: 1rem;
                    margin-left: 1rem;
                    font-weight: bold;
                }
                > div#result-message{
                    display: none;
                    margin-top: 1rem;
                    font-weight: bold;
                    // color: palette(Cyan, 500);
                    background-color: palette(Amber, 400);
                    padding: .5rem 1rem;
                    border-radius: .5rem;
                }
            }
        }
        > div.column{
            padding: 2rem 3rem;
            background-color: #F5F6F7;
            &#column2{
                padding-right: 5rem;
                i{
                    position: relative;
                    top: -1px;
                }
            }
            > p{
                text-transform: uppercase;
                font-weight: bold;
                margin-bottom: .5rem;
                > a{
                    text-decoration: none;
                    color: inherit;
                }
            }
        }
        > div#bottom{
            background-color: #37474F;
            grid-column: 1 / span 2;
            padding: 1rem 3rem;
            color: #fff;
        }
        > div#icons{
            display: none;
            background-color: #37474F;
            padding: 1rem 0;
            color: #fff;
            > i{
                margin-right: 1rem;
            }
        }
        @include mediaQueryCutMax(sm){
            grid-template-columns: 1fr auto;
            > div#newsletter{
                padding: 1rem 2rem;
            }
            > div.column{
                padding: 1rem 2rem;
                &#column1{
                    
                }
                &#column2{
                    grid-column: 1/ -1;
                    display: flex;
                    justify-content: space-between;
                    padding: 1rem 2rem;
                    > p{
                        margin-right: 1rem;
                        &:last-of-type{
                            margin-right: 0;
                        }
                    }
                }
            }
            > div#bottom{
                grid-column: 1;
                padding: 1rem 2rem;
            }
            > div#icons{
                grid-column: 2;
                text-align: right;
                padding: 1rem 2rem;
            }
        }
        @include mediaQueryCutMax(xs){
            grid-template-columns: auto 1fr;
            > div#newsletter{
                grid-column: 1 / -1 !important;
                > form{
                    > input{
                        width: 11rem;
                    }
                }
            }
            > div.column{
                grid-column: 1 / -1 !important;
                &#column1{
                    display: block;
                }
                &#column2{
                    display: block;
                }
            }
            > div#bottom{
                grid-column: 1;
            }
            >div#icons{
                grid-column: 2;
                white-space: nowrap;
                
            }
        }
    }
</style>